"use client"

import * as Sentry from "@sentry/nextjs"
import { useEffect } from "react"
import ErrorPage from "components/ErrorPage"

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="en">
      <body>
        <ErrorPage />
      </body>
    </html>
  )
}
